import { useEffect, useRef } from 'react';

const badges = [
  {
    image: 'https://readdy.ai/api/search-image?query=Professional%20courier%20delivering%20a%20premium%20package%20at%20a%20modern%20house%20entrance%2C%20fast%20delivery%20service%20concept%2C%20warm%20natural%20lighting%2C%20clean%20composition%20with%20soft%20shadows%2C%20editorial%20photography%20style%20with%20delivery%20truck%20in%20background&width=200&height=200&seq=trust-truck-2026&orientation=squarish',
    title: 'Brza dostava',
    subtitle: '2-4 radna dana',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Premium%20quality%20acrylic%20house%20number%20plaque%20with%20gold%20lettering%20on%20black%20background%2C%20close-up%20product%20shot%20showing%20material%20quality%20and%20craftsmanship%2C%20soft%20studio%20lighting%20with%20clean%20minimal%20composition%2C%20luxury%20signage%20detail&width=200&height=200&seq=trust-quality-2026&orientation=squarish',
    title: 'Premium kvalitet',
    subtitle: 'Garancija 5 godina',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Hands%20installing%20an%20elegant%20house%20number%20on%20a%20modern%20wall%20with%20mounting%20hardware%20and%20tools%2C%20DIY%20home%20improvement%20close-up%2C%20warm%20natural%20lighting%2C%20professional%20editorial%20photography%20with%20clean%20composition%20and%20soft%20shadows&width=200&height=200&seq=trust-install-2026&orientation=squarish',
    title: 'Lako postavljanje',
    subtitle: 'Kompletan set uključen',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Customer%20satisfaction%20concept%20with%20a%20happy%20homeowner%20receiving%20a%20premium%20package%20at%20the%20door%2C%20smiling%20and%20holding%20a%20beautiful%20house%20number%20sign%2C%20warm%20daylight%2C%20professional%20lifestyle%20photography%20with%20clean%20background%20and%20soft%20shadows&width=200&height=200&seq=trust-guarantee-2026&orientation=squarish',
    title: '100% garancija',
    subtitle: 'Povrat novca 30 dana',
  },
];

export default function TrustBadgesSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const els = entry.target.querySelectorAll('.reveal');
            els.forEach((el, i) => {
              setTimeout(() => {
                el.classList.add('animate-in');
              }, i * 100);
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="w-full bg-white border-y border-background-200 py-8 md:py-10">
      <div className="w-full px-4 md:px-6 max-w-[1450px] mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {badges.map((badge, index) => (
            <div
              key={badge.title}
              className="reveal opacity-0 translate-y-4 transition-all duration-700 ease-out flex items-center gap-3 md:gap-4"
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex-shrink-0 rounded-full overflow-hidden border border-background-200">
                <img
                  src={badge.image}
                  alt={badge.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <div className="font-label text-sm font-semibold text-foreground-950">{badge.title}</div>
                <div className="text-xs text-foreground-600">{badge.subtitle}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .reveal.animate-in {
          opacity: 1;
          transform: translateY(0);
        }
      `}</style>
    </section>
  );
}